import React from 'react';
import { styles } from './CouponModal.css';
import { LoadingSkeleton } from '../LoadingSkeleton/LoadingSkeleton';
import { Barcode } from '../Barcode';

type BarcodeContainerProps = {
  couponCode: string;
  barcode?: string;
  barcodeLabel?: string;
  additonalInstructions?: JSX.Element;
};

export const BarcodeContainer = ({
  couponCode,
  barcode,
  barcodeLabel,
  additonalInstructions,
}: BarcodeContainerProps) => {
  return barcode ? (
    <div className={styles.barcodeContainer}>
      <h5 className={styles.barcodeLabel}>{barcodeLabel || 'Redeem in-store'}</h5>
      <div className={styles.barcodeInstructions}>
        {additonalInstructions || 'Show the barcode to our staff at the counter.'}
      </div>
      <div className={styles.barcodeImageContainer}>
        <Barcode barcodeBase64={barcode} />
        <h4 className={styles.barcodeText}>{couponCode}</h4>
      </div>
    </div>
  ) : (
    <LoadingSkeleton.Image
      className={styles.loadingSkeleton}
      border="none"
      aspectRatio={2}
      shouldShimmer={true}
      width="50%"
    />
  );
};
